import { MixpanelTracking } from '@/services/mixpanel';
import './helpAndSupport.scss';

import ArrowOutwardOutlinedIcon from '@mui/icons-material/ArrowOutwardOutlined';
import CloseIcon from '@mui/icons-material/Close';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import { IconButton, Typography, Link } from '@mui/material';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import * as React from 'react';
import { MixpanelEvent } from '@/services/eventEnums';
import { useTranslation } from 'react-i18next';
import { platformApps } from '@/constants/enums/enums';

type Anchor = 'right';

export default function HelpAndSupport() {
  const [state, setState] = React.useState({
    right: false,
  });
  const { t } = useTranslation('drawer');

  const toggleDrawer =
    (anchor: Anchor, open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
      if (
        event.type === 'keydown' &&
        ((event as React.KeyboardEvent).key === 'Tab' ||
          (event as React.KeyboardEvent).key === 'Shift')
      ) {
        return;
      }

      setState({ ...state, [anchor]: open });
    };

  const list = (anchor: Anchor) => (
    <>
      <Box className="drawer-header">
        <Typography variant="h5" aria-label="Help and Support">
          {t('hasTitle')}
        </Typography>
        <IconButton
          aria-label="Close Help and Support"
          name="Close Help and Support"
          onClick={toggleDrawer(anchor, false)}
        >
          <CloseIcon />
        </IconButton>
      </Box>
      <Box className="drawer-content">
        <List className="help-support-list">
          <ListItem>
            <Link
              className="cursor-pointer"
              target="_blank"
              href="mailto:support@skywatch.com"
              onClick={() => {
                MixpanelTracking.getInstance().track(MixpanelEvent.HELP_SUPPORT_CHAT_CLICK);
              }}
            >
              {t('contactSupport')}
            </Link>
          </ListItem>
          <ListItem>
            <Link
              href="https://support.skywatch.com/"
              target="_blank"
              onClick={() => {
                MixpanelTracking.getInstance().track(MixpanelEvent.HELP_HELP_CENTER_CLICK);
              }}
            >
              {t('helpCenter')} <ArrowOutwardOutlinedIcon />
            </Link>
          </ListItem>

          {process.env.NEXT_PUBLIC_PLATFORM_APP === platformApps.HUB && (
            <ListItem>
              <Link
                href={process.env.NEXT_PUBLIC_API_REFERENCE}
                sx={{ color: 'white' }}
                target="blank"
                onClick={() => {
                  MixpanelTracking.getInstance().track(
                    MixpanelEvent.HELP_SUPPORT_API_REFERENCE_CLICK
                  );
                }}
              >
                {t('my-account:apiReference')} <ArrowOutwardOutlinedIcon />
              </Link>
            </ListItem>
          )}
        </List>
      </Box>
    </>
  );

  return (
    <Box>
      {(['right'] as const).map(anchor => (
        <React.Fragment key={anchor}>
          <IconButton
            aria-label="Open Help and Support"
            name="Open Help and Support"
            onClick={toggleDrawer(anchor, true)}
          >
            <HelpOutlineOutlinedIcon />
          </IconButton>
          <Drawer
            ModalProps={{
              className: 'skywatch-drawer-wrapper',
            }}
            PaperProps={{ className: 'skywatch-drawer' }}
            anchor={anchor}
            open={state[anchor]}
            onClose={toggleDrawer(anchor, false)}
          >
            {list(anchor)}
          </Drawer>
        </React.Fragment>
      ))}
    </Box>
  );
}
